import React from 'react';
import ReactDOM from 'react-dom';
import AppRoute from './Route';

ReactDOM.render(<AppRoute />, document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js